module.exports = __webpack_public_path__ + "img/iconoatencionp.12262013.svg";